import Head from 'next/head'
import React from 'react'

export type PageProps = {
  title?: string
  children?: React.ReactNode
  [extraProps: string]: unknown
}

const Page: React.FC<PageProps> = ({ title, children, ...props }) => (
  <div {...props}>
    <Head>
      <title key='title'>{title}</title>
      <meta key='og:title' content={title} property='og:title' />
      <meta key='twitter:title' content={title} name='twitter:title' />
    </Head>
    {children}
  </div>
)

export default Page
